export const PageURL = {
    initiateResetPassword: '/reset-password-link',
    initiateResetPasswordResetSuccess: '/initiate-reset-password-success',
    resetPassword: '/reset-password',
}